import { PageId } from 'constants/pages'
import type { TStep } from 'src/types'
import { STEPS_INTL_2LW } from './steps'

// abtest_web_127_first_screen, group C: same flow as STEPS_INTL_2LW, but the
// first screen (loader) is replaced with the intro certificate screen.
export const STEPS_INTL_2LW_INTRO_CERTIFICATE: TStep[] = [
  { pageId: PageId.INTRO_CERTIFICATE_INTL_2LW },
  ...STEPS_INTL_2LW.slice(1),
]
